import React from "react";
import "../css/Service.css";
import Review from "./review";

const services = [
  {
    title: "Prescription Fulfillment",
    description: "Accurate, timely, and dependable prescription services tailored to your needs.",
    link: "/services/prescription-fulfillment",
    icon: "💊",
  },
  {
    title: "Vaccinations",
    description: "Protect your health with our convenient immunization services.",
    link: "/services/Vaccinations",
    icon: "🩺",
  },
  {
    title: "OTC Medications & Essentials",
    description: "A wide selection of over-the-counter products to support everyday wellness.",
    link: "/services/over-the-counter-medications",
    icon: "🛒",
  },
  {
    title: "Free Local Delivery",
    description: "Receive your medications and health products without hassle, delivered to your door.",
    link: "/services/free-home-delivery",
    icon: "🚚",
  },
];

function Service() {
  return (
    <div className="service-page">
        <div className="service-banner">
          <img
            src={'/img_10.748Z.png'}
            alt="Service Banner"
            className="service-banner-img"
          />
          <div className="service-banner-overlay"></div>
          <div className="service-banner-content">
            <h1> Our Services</h1>
          </div>
        </div>

      <header className="service-header">
        <h1>Quality Pharmacy: Your Trusted Partner in Health</h1>
        <p>
          At Quality Pharmacy, we are committed to delivering high-quality, comprehensive pharmacy care tailored to your needs. Our team combines expertise with personalized service to ensure your health and convenience come first.
        </p>
      </header>
      <div className="service-cards">
        {services.map((service, idx) => (
          <a href={service.link} className="service-card" key={idx}>
            <div className="service-icon">{service.icon}</div>
            <h2>{service.title}</h2>
            <p>{service.description}</p>
            <span className="service-link">Learn More &rarr;</span>
          </a>
        ))}
      </div>
      <footer className="service-footer">
      {/**  <p>
          With Shoreham Drugs, you can count on professional care, reliable service, and a seamless pharmacy experience.
        </p> */}
      </footer>
      <Review/>
    </div>
  );
}

export default Service;